import React from 'react';
import { Col, Row } from 'react-bootstrap';
import _ from 'lodash';
import { BooleanValueTemplate } from './valuesTemplates';
import { DocumentButtonTemplate, DocumentsButtonOptions } from './buttonsTemplates';
import { Skeleton } from 'primereact/skeleton';

// Определяем, что может быть в колонке: поле или кнопка
export type ColumnField = {
  format: 'field';
  caption: string;
  field: string;
  valueType?: string;
};

export type ColumnButton = {
  format: 'button';
  type: 'documents';
  caption: string;
};

export type ColumnItem = ColumnField | ColumnButton;

export type ButtonOptions = {
    disabled?: boolean, 
    isLoading?: boolean,
}

export type ButtonsOptions = {
  documents?: DocumentsButtonOptions;
};

export type CardInfoSectionProps = {
  sectionOptions: {
    sectionName: string;
    columns: ColumnItem[][];
  };
  data: Record<string, any> | null;
  buttonsOptions?: ButtonsOptions | null;
};

export function CardInfoSection({
  sectionOptions: { sectionName, columns },
  data,
  buttonsOptions,
}: CardInfoSectionProps) {
  return (
    <div className="card-info-section-div">
      <p className="section-name">{sectionName}</p>

      <Row>
        {columns.map((colItems, colIndex) => (
          <Col xs={12} sm={12} md={6} lg={3} key={colIndex}>
            {colItems.map((item, idx) => {
              if (item.format === 'field') {
                const { caption, field } = item;
                let fieldValue: any = _.get(data, field);
                let loading = data?.isLoadingMainData;

                if (typeof fieldValue === 'object' && fieldValue !== null) {
                  loading = fieldValue.isLoading;
                  fieldValue = fieldValue.value;
                }

                return (
                  <div className="field-block" key={idx}>
                    <div className="field-caption">{caption}</div>
                    {loading ? (
                      <Skeleton className="field-value-skeleton" />
                    ) : typeof fieldValue === 'boolean' ? (
                      <BooleanValueTemplate value={fieldValue} />
                    ) : (
                      <div className="field-value" style={{ whiteSpace: 'pre-wrap' }}>
                        {fieldValue ?? 'Не указано'}
                      </div>
                    )}
                  </div>
                );
              }

              if (item.format === 'button' && item.type === 'documents') {
                const opts = buttonsOptions?.documents ?? {
                  numberOfDocuments: 0,
                  disabled: true,
                  isLoading: false,
                };
                return (
                  <div className="button-block" key={idx}>
                    <DocumentButtonTemplate
                      caption={item.caption}
                      buttonOptions={opts}
                    />
                  </div>
                );
              }

              return null;
            })}
          </Col>
        ))}
      </Row>
    </div>
  );
}
